import Echo from 'laravel-echo';
import { io } from 'socket.io-client'; // this is the correct import

/*

// THIS IS PUSHER VERSION AND HAS SOME ISSUES. MOVED TO SOCKET-IO.CLIENT

import Pusher from 'pusher-js';


window.Pusher = Pusher;
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '8d37aeffdef7bbe36b8eb33e7fe98b26', // Your echo key
  cluster: 'mt1',
  wsHost: '192.168.1.111',               // Host IP
  wsPort: 6001,
  forceTLS: false,
  disableStats: true,
  enabledTransports: ['ws'],
});

*/





export function createEchoClient() {
  window.io = io;

  return new Echo({
    broadcaster: 'socket.io',
    path: '/socket.io',
    host: window.config.echoserver,
    reconnection: true,
  //  reconnectionAttempts: 10,     // optional, default is Infinity
    reconnectionDelay: 1000,      // 1 second between attempts
    reconnectionDelayMax: 5000,   // backoff max
    transports: ['websocket', 'polling'], // optional, forces WebSocket-only
  });
}
